/**
 * Trạng thái phê duyệt nội dung danh mục
 */
export default {
    Pending: 1,
    Add: 2,
    Refuse: 4,
    Merge: 3
};
